import AppAPI from '../../lib/api';


export const setEvent = (eventData, propertyId) => (dispatch) => new Promise(async (resolve, reject) => {
  return AppAPI.bengineapi.get(`${propertyId}/event/${eventData}/`)
    .then((res) => {
      dispatch({
        type: 'SET_EVENT',
        data: res
      });
      return resolve(res);
    })
    .catch(err => {
      dispatch({
        type: 'SET_EVENT',
        data: {}
      });
      return reject(err);
    });
});

